import VwoABTest from './dynamicTestPlataform/vwoABTest'
import vwoCampaignKeyEnum from './dynamicTestPlataform/vwoCampaignKeyEnum'
import vwoTrackKeyEnum from './dynamicTestPlataform/vwoTrackKeyEnum'
import vwoVariantEnum from './dynamicTestPlataform/vwoVariantEnum'
import generalConfigAbTest from '../helpers/vwo/generalConfigAbTest'
import stepProtectionsTestMixin from './step-protections-test-mixin'
import { COUNTRIES_ISO_CODE } from '../../config/countries-code'

export default {
  mixins: [
    generalConfigAbTest,
    stepProtectionsTestMixin
  ],
  methods: {
    abTestPayment () {
      return true
    },
    async abAsyncConfirmation () {
      try {
        const user = await this.$store.getters['user/getLoggedUser']
        const userId = user?.id ?? 'LOGGED_OUT_ID'

        const vwoAbTest = new VwoABTest()
        const variantName = await vwoAbTest.getVwoVariationName(userId, vwoCampaignKeyEnum.ASYNC_CONFIRMATION)
        await vwoAbTest.setVwoTrackABTest(userId, vwoCampaignKeyEnum.ASYNC_CONFIRMATION, vwoTrackKeyEnum.METRIC_KEY_NEW_PAYMENT)

        return variantName === vwoVariantEnum.ASYNC_VARIANT
      } catch (e) {
        this.$bugsnag.notify(e)
      }
    },
    async abForceInteractionRentalCover () {
      try {
        return await this.isVariationAbTest(vwoCampaignKeyEnum.INTERACTION_WITH_RENTAL_COVER, vwoVariantEnum.FORCE_INTERACTION)
      } catch (e) {
        this.$bugsnag.notify(e)
        return false
      }
    },
    async abcStepRentalCover() {
      try {
        const userCookieUuid = this.$appCookie.get('userUuid')
        const { residenceCode } = this.$route.params
        const locale = this.$store.getters.getLocale
        const bookingConfig = this.$store.getters['booking/getBookingPageConfigurePayOnConfigure']
        const itinerary = this.$store.getters['search/getItinerary']

        const isBrazil = residenceCode === COUNTRIES_ISO_CODE.BRA
        const isPtBr = locale === 'pt-br'
        const hasRentalCover = bookingConfig.rentalCover !== null
        const itineraryConditionToStop = itinerary.IsDomestic && itinerary.Daily > 27

        if (!hasRentalCover || !isPtBr || !isBrazil || itineraryConditionToStop) {
          return false
        }

        const vwoCampaignKey = itinerary.IsDomestic
          ? vwoCampaignKeyEnum.STEP_RENTALCOVER_ABC_DOMESTIC
          : vwoCampaignKeyEnum.STEP_RENTALCOVER_OUTBOUND

        const vwoAbTest = new VwoABTest()
        const variantName = await vwoAbTest.getVwoABTest(userCookieUuid, vwoCampaignKey)

        return variantName || vwoVariantEnum.CONTROL
      } catch (error) {
        this.$bugsnag.notify(error)
        return false
      }
    },

    async getVariantStepProtectionsCampaign() {
      try {
        const vwoCampaignKey = await this.getCampaignStepProtections()

        if (!vwoCampaignKey) {
          return vwoVariantEnum.CONTROL
        }

        const userCookieUuid = this.$appCookie.get('userUuid')
        const vwoAbTest = new VwoABTest()
        const variantName = await vwoAbTest.getVwoABTest(userCookieUuid, vwoCampaignKey)

        return variantName || vwoVariantEnum.CONTROL
      } catch (error) {
        this.$bugsnag.notify(error)
        return false
      }
    }
  }
}
